// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.like-button-container {
    display: flex;
    align-items: center;
}

.like-button-icon {
    color: #2E3F80;
    cursor: pointer;
}

.like-button-icon:hover {
    opacity: 0.8;
}

.like-button-icon-grid {
    font-size: 1rem;
}

.like-button-icon-flyout {
    font-size: 1.25rem;
}

.like-button-count {
    color: #767786;
    margin-left: 8px;
}

.like-button-count-grid {
    font-size: 12px;
}

.like-button-count-flyout {
    font-size: 14px;
}
`, "",{"version":3,"sources":["webpack://./src/components/grid/LikeButton.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,eAAe;AACnB","sourcesContent":[".like-button-container {\n    display: flex;\n    align-items: center;\n}\n\n.like-button-icon {\n    color: #2E3F80;\n    cursor: pointer;\n}\n\n.like-button-icon:hover {\n    opacity: 0.8;\n}\n\n.like-button-icon-grid {\n    font-size: 1rem;\n}\n\n.like-button-icon-flyout {\n    font-size: 1.25rem;\n}\n\n.like-button-count {\n    color: #767786;\n    margin-left: 8px;\n}\n\n.like-button-count-grid {\n    font-size: 12px;\n}\n\n.like-button-count-flyout {\n    font-size: 14px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
